
import { LangCode, Language } from "@/CrowTypes";
import { ConfigStoreModule } from "@/store/ConfigStore";
import { UserChoicesStoreModule } from "@/store/UserChoicesStore";
import Vue from "vue";

export default Vue.extend({
  name: "LanguageSelector",
  computed: {
    availableLanguages(): Language[] {
      return ConfigStoreModule.availableLanguages;
    },
    selectedLanguageCode: {
      get: function (): LangCode {
        return UserChoicesStoreModule.selectedLanguageCode;
      },
      set: function (code: LangCode) {
        UserChoicesStoreModule.setSelectedLanguageCode(code);
      }
    },
    selectedLanguageLabel(): string {
      return UserChoicesStoreModule.selectedLanguageLabel
    } 
  },
});
